import { Box, Divider, styled, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

export const StyleBoxMain = styled(Box)(() => ({
  width: "100%",
  height: "100%",
}));
export const StyledBoxWidth = styled(Box)(() => ({
  width: "100%",
  maxWidth: "1400px",
  margin: "0 auto",
}));
export const StyledGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "50px",
  [theme.breakpoints.down("xl")]: {
    gap: "60px",
  },
  [theme.breakpoints.down("md")]: {
    paddingTop: "30px",
    gap: "30px",
  },
  [theme.breakpoints.down("sm")]: {
    paddingTop: "30px",
    gap: "30px",
  },
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: "0px 78px",
  [theme.breakpoints.down("xl")]: {
    padding: "0px 48px",
  },
  [theme.breakpoints.down("md")]: {
    padding: "23px !important",
  },
  [theme.breakpoints.down("sm")]: {
    paddingBottom: "20px",
    padding: "23px !important",
  },
}));
export const StyledBoxInner = styled(Box)(() => ({}));
export const StyledTypographyWel = styled(Typography)(({ theme }) => {
  return {
    fontSize: theme.typography.extraSmall.fontSize,
    textAlign: "left",
    display: "block",
  };
});
export const StyledTypographyFor = styled(Typography)(({ theme }) => {
  return {
    fontSize: theme.typography.extraSmall.fontSize,
    color: theme.palette.custom.danger,
    margin: "16px 0px",
    textAlign: "right",
    display: "block",
    cursor: "pointer",
  };
});
export const StyleTypographyText = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.warning,
  fontSize: theme.typography.xxLarge.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  textAlign: "left",
  display: "block",

  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.extraLarge.fontSize,
  },
}));
export const StyledTypographyDo = styled(Typography)(({ theme }) => ({
  marginTop: "55.5px",
  textAlign: "center",

  [theme.breakpoints.down("sm")]: {
    marginTop: "30.5px",
  },

  fontSize: theme.typography.extraSmall.fontSize,
}));

export const StyledBoxDis = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
}));
export const StyledBoxFlex = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: "10px",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: "0px",
  },
}));
export const StyledBoxWidthInput = styled(Box)(({ theme }) => ({
  width: "50%",
  "& .MuiFormHelperText-root": {
    marginRight: 0,
  },

  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

export const StyleSpan = styled("span")(({ theme }) => ({
  paddingLeft: "3px",
  fontWeight: theme.typography.fontWeight.bold,
  textDecoration: "underline",
  cursor: "pointer",
}));
export const StyledTypographyOr = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeight.bold,
  color: theme.palette.custom.lightGrey,
  padding: "0px 10px",
  fontSize: theme.typography.extraSmall.fontSize,
}));
export const StyledOrBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  margin: "21px 0px",
}));
export const StyledBoxPad = styled(Box)(() => ({
  paddingTop: "20px",
}));
export const StyledDivider = styled(Divider)(() => ({
  flexGrow: 1,
}));

export const StyledGridContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    width: "100%",
    display: "flex",
    alignItems: "center",
  },
}));
